import React from 'react';
import { Award } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { BADGES } from './joinConfig';

export const RecruiterBadge = ({ badge, size = 'sm', testid = 'recruiter-badge' }) => {
  const { language } = useLanguage();
  const b = BADGES[badge];
  if (!b) return null;
  const sm = size === 'sm';
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1 rounded-full font-bold ${sm ? 'px-2 py-0.5 text-[10px]' : 'px-3 py-1 text-xs'}`}
      style={{ background: `${b.color}22`, color: b.text, border: `1px solid ${b.color}` }}>
      <Award className={sm ? 'h-3 w-3' : 'h-4 w-4'} /> {language === 'bn' ? b.bn : b.label}
    </span>
  );
};
